const apiKeys = {
    dynamic: {
        dp: 'AIzaSyCaLtitorFN9YJ9JslS4KqCU4aKJMXxbk0',
        flights: 'AIzaSyBSnHHw5F_YSc0NQGe1UB__clInuPlgOgc',
        upsell: 'AIzaSyBSnHHw5F_YSc0NQGe1UB__clInuPlgOgc',
        accommodationPostBooking: 'AIzaSyBSnHHw5F_YSc0NQGe1UB__clInuPlgOgc',
    },
};

function getDynamicMapApiKey() {
    return apiKeys.dynamic[Odigeo.Utils.getAppInGlobalScope()];
}

module.exports = {
    getDynamicMapApiKey,
};

